export default __webpack_public_path__ + "static/media/home-delivery.0964a22d.svg";